import angular from 'angular'
import template from './template.html'

angular.module('nominas.cotizacion')
  .component('nominasCotizacionEmpleadosAgregar', {
    controller: Component,
    template: template,
    bindings: {
      proyectos: '<',
      modalidad: '<',
      onAgregar: '<',
      onCancelar: '&',
    },
  });

function Component($q, NominasCotizacion) {
  let $ctrl = this;
  // Flags
  $ctrl.creandoEmpleado = false;
  $ctrl.empleadoExiste = undefined;
  $ctrl.generandoData = false;
  $ctrl.verificandoEmpleado = false;
  // Variables
  $ctrl.proyectosEmpleados = null;
  $ctrl.proyectosConceptos = null;
  $ctrl.data = {
    empleado: undefined,
    proyecto: undefined,
    subtotal: 0,
  };
  // Methods
  $ctrl.agregar = agregar;
  $ctrl.cancelar = cancelar;
  $ctrl.crearEmpleado = crearEmpleado;
  $ctrl.obtenerIdEmpleado = obtenerIdEmpleado;

  init();

  function agregar() {
    $ctrl.generandoData = true;
    return NominasCotizacion
      .listConceptos($ctrl.data.proyecto.ID_Proyecto)
      .then(function (conceptos) {
        let data = {
          ID_Proyecto: $ctrl.data.proyecto.ID_Proyecto,
          ID_Empleado: $ctrl.data.empleado.ID_Empleado,
          Proyecto: $ctrl.data.proyecto.Proyecto,
          Empleado: $ctrl.data.empleado.Empleado,
          RFC: $ctrl.data.empleado.RFC,
          Subtotal: $ctrl.data.subtotal,
          Viaticos: 0,
          Incentivos: 0,
          Deducciones: conceptos.Deducciones.map(function (item) {
            item.Importe = 0;
            return item;
          }),
          Percepciones: conceptos.Percepciones.map(function (item) {
            item.Importe = 0;
            return item;
          }),
        };

        $ctrl.onAgregar(data);
      });
  }

  function cancelar() {
    $ctrl.onCancelar();
  }

  function crearEmpleado() {
    $ctrl.creandoEmpleado = true;

    NominasCotizacion
      .crearEmpleado($ctrl.data.proyecto.ID_Proyecto, $ctrl.data.empleado.RFC)
      .then(obtenerIdEmpleado)
      .finally(function () {
        $ctrl.creandoEmpleado = false;
      });
  }

  function init() {
    return NominasCotizacion
      .listEmpleados($ctrl.modalidad)
      .then(function (proyectosEmpleados) {
        $ctrl.proyectosEmpleados = angular.copy(proyectosEmpleados);
      });
  }

  function obtenerIdEmpleado() {
    $ctrl.empleadoExiste = undefined;
    if ($ctrl.data.proyecto && $ctrl.data.empleado) {
      $ctrl.verificandoEmpleado = true;

      NominasCotizacion
        .obtenerIdEmpleado($ctrl.data.proyecto.ID_Proyecto, $ctrl.data.empleado.RFC)
        .then(function (ID_Empleado) {
          $ctrl.data.empleado.ID_Empleado = ID_Empleado;
          $ctrl.empleadoExiste = ID_Empleado !== null;
        }).finally(function () {
        $ctrl.verificandoEmpleado = false;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cotizacion/components/empleados/agregar/component.js